// import CharacterSlotHide from './CharacterSlotHide';
import StarsPopup from './StarsPopup';
import ButtonSimpleVO from './buttons/ButtonSimpleVO';
import ButtonResult from './buttons/ButtonResult';
import ExplainerVOController from '../controller/ExplainerVOController';
import ElinorForward from './ElinorForward';
import { getGA } from 'analytics/GoogleAnalytics';
import { GA_LABEL_STAR_1, GA_LABEL_STAR_2, GA_LABEL_STAR_3 } from 'app/constants/AppConstants';

export default class OverlayResultHide extends Phaser.Image {
  constructor(game, charsData, foundData, screenshots) {
    super(game, 0, 0);
    this.loadTexture('bg_location_' + this.game.controller.location);

    this.screenshots = screenshots;
    this.charsData = charsData;
    this.foundData = foundData;

    this.idleTime = 0;
    this.idlePlayed = false;
    //
    this.onCloseResult = new Phaser.Signal();

    this.addCharacters(charsData, foundData);
    this.addButtons();

    // add elinor
    this.elinor = new ElinorForward(this.game);
    this.elinor.x = this.game.defaultWidth / 2 - 450;
    this.elinor.y = this.game.defaultHeight;
    this.addChild(this.elinor);
    this.elinor.enable();
    this.elinor.onClick.add(this.onClickElinor, this);

    //
    this.voController = new ExplainerVOController(this.game);

    //
    this.game.time.events.add(500, this.onClickElinor, this);

    //
    // this.alpha = 0;
    // this.game.add.tween(this).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true);
  }

  addCharacters(charsData, foundData) {
    // add characters
    this.slots = [];
    const dist = 210;
    const x0 = -(charsData.length - 1) * 0.5 * dist;
    this.charsGroup = this.game.make.group();
    this.charsGroup.x = this.game.defaultWidth / 2;
    this.charsGroup.y = 360;
    for (let i = 0; i < charsData.length; i++) {
      const id = charsData[i].id;
      const { dx, dy, bmd2 } = this.screenshots[id];
      const slot = new ButtonResult({ game: this.game, dx, dy, bmd: bmd2, id });
      slot.x = x0 + i * dist;
      slot.onTap.add(this.handleTapChar, this);
      this.charsGroup.addChild(slot);

      const popup = new StarsPopup(this.game, foundData[id].rating + 1, false);
      popup.y = -110;
      popup.scale.set(1);
      slot.stars = popup;
      slot.addChild(popup);

      this.slots.push(slot);
    }
    this.addChild(this.charsGroup);
  }

  addButtons() {
    // add buttons
    this.btnReplay = new ButtonSimpleVO({
      game: this.game,
      up: 'btn_replay',
      over: 'btn_replay',
      voID: 'ui_01_elinor_031',
    });
    this.btnReplay.onInputDown.add(this.handleReplayDown, this);
    this.btnReplay.position.set(this.game.defaultWidth / 2 - 80, 600);
    this.addChild(this.btnReplay);

    this.btnNext = new ButtonSimpleVO({
      game: this.game,
      up: 'btn_next',
      over: 'btn_next',
      voID: 'ui_01_elinor_015',
    });
    this.btnNext.onInputDown.add(this.handleNextDown, this);
    this.btnNext.position.set(this.game.defaultWidth / 2 + 90, 600);
    this.addChild(this.btnNext);
  }

  handleTapChar(slot) {
    this.endStarVO();

    this.idleTime = -1;
    this.idlePlayed = true;
    if (this.idleVO && this.idleVO.isPlaying) {
      this.idleVO.stop();
      this.idleVO = null;

      this.btnReplay.canPlayVO = true;
      this.btnNext.canPlayVO = true;
    }

    this.elinor.disable();
    this.btnReplay.input.enabled = false;
    this.btnNext.input.enabled = false;

    this.selectedSlot = slot;

    // hide icons
    for (let i = 0; i < this.slots.length; i++) {
      this.slots[i].disable();
      if (this.slots[i] !== slot) {
        this.game.add.tween(this.slots[i].scale).to({ x: 0, y: 0 }, 300, null, true);
      } else {
        this.game.add.tween(this.slots[i].scale).to({ x: 0, y: 0 }, 100, null, true, 200);
      }
    }

    // hide buttons
    this.game.add.tween(this.btnReplay).to({ y: 800 }, 300, Phaser.Easing.Back.In, true);
    this.game.add.tween(this.btnNext).to({ y: 800 }, 300, Phaser.Easing.Back.In, true, 100);

    //
    this.game.time.events.add(300, this.showHidingPlace, this);

    //
    const labels = [GA_LABEL_STAR_1, GA_LABEL_STAR_2, GA_LABEL_STAR_3];
    const label = labels[slot.stars.stars - 1];
    // console.log(slot.stars.stars, label);
    getGA().track({ action: 'StarExplainer', label: label });
  }

  showHidingPlace() {
    const charId = this.selectedSlot.characterId;
    this.bubble = this.game.make.image(
      this.game.defaultWidth / 2,
      this.game.defaultHeight / 2,
      'explain_bubble'
    );
    this.screenshot = this.game.make.image(0, 0, this.screenshots[charId].bmd);
    this.screenshot.anchor.set(0.5);
    this.bubble.addChild(this.screenshot);
    this.bubble.anchor.set(0.5);
    this.addChild(this.bubble);

    // animation
    this.bubble.scale.set(0);
    this.game.add.tween(this.bubble.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);

    // move elinor to front and enlarge
    this.addChild(this.elinor);
    const rb = this.elinor.getRootBone();
    const sc = rb.scaleX * 1.3;
    this.game.add.tween(rb).to({ scaleX: sc, scaleY: sc }, 300, null, true);

    // add timeout to auto hide bubble - later controlled by VO
    this.game.time.events.add(500, this.playVO, this);
  }

  playVO() {
    this.elinor.talk();
    const charId = this.selectedSlot.characterId;
    const data = this.foundData[charId];
    this.voController.init(charId, data.explainerData, data.rating, null);
    this.voController.onEnd.addOnce(this.hideBubble, this);
  }

  hideBubble() {
    this.elinor.idle();
    // hide bubble and destroy on out
    this.game.add
      .tween(this.bubble.scale)
      .to({ x: 0, y: 0 }, 300, Phaser.Easing.Back.In, true)
      .onComplete.add(this.handleHideBubble, this);

    // shrink elinor
    const rb = this.elinor.getRootBone();
    const sc = rb.scaleX / 1.3;
    this.game.add.tween(rb).to({ scaleX: sc, scaleY: sc }, 500, null, true);

    // show slots
    for (let i = 0; i < this.slots.length; i++) {
      if (this.slots[i] !== this.selectedSlot) {
        this.game.add.tween(this.slots[i].scale).to({ x: 1, y: 1 }, 300, null, true, 300);
      } else {
        this.game.add.tween(this.slots[i].scale).to({ x: 1, y: 1 }, 300, null, true);
      }
    }

    // show buttons
    this.game.add.tween(this.btnReplay).to({ y: 600 }, 300, Phaser.Easing.Back.Out, true, 300);
    this.game.add.tween(this.btnNext).to({ y: 600 }, 300, Phaser.Easing.Back.Out, true, 400);
  }

  handleHideBubble() {
    for (let i = 0; i < this.slots.length; i++) {
      this.slots[i].enable();
    }

    this.elinor.enable();
    this.btnReplay.input.enabled = true;
    this.btnNext.input.enabled = true;

    this.screenshot.destroy();
    this.bubble.destroy();
    this.screenshot = null;
    this.bubble = null;

    this.selectedSlot = null;

    // reset idle timer
    // this.idleTime = 0;
  }

  removeListeners() {
    this.btnReplay.onInputDown.remove(this.handleReplayDown, this);
    this.btnNext.onInputDown.remove(this.handleNextDown, this);
  }

  handleReplayDown() {
    this.removeListeners();
    this.endStarVO();
    this.onCloseResult.dispatch(true);
  }

  handleNextDown() {
    this.removeListeners();
    this.endStarVO();
    this.onCloseResult.dispatch(false);
  }

  update() {
    this.elinor.update();
    super.update();

    // play idle prompt
    if (this.idleTime > -1 && !this.idlePlayed) {
      this.idleTime += this.game.time.elapsedMS / 1000;
      if (this.idleTime > 5) {
        this.idleTime = -2;
        // this.idlePlayed = true;
        const voId = this.game.device.desktop ? 'ex_star_idle_click' : 'ex_star_idle_tap';
        this.idleVO = this.game.sounds
          .playVO(voId, {
            spriteID: 'vo_explainer_stars',
            onComplete: this.endIdleVO,
            onCompleteScope: this,
          })
          .get(voId);
        this.game.springRollCaptionsPlugin.playCaption(voId);
        this.elinor.talk();

        //
        this.btnReplay.canPlayVO = false;
        this.btnNext.canPlayVO = false;
      }
    }
  }

  endIdleVO() {
    if (this.idleTime === -2) {
      this.idleTime = 0;
      this.idleVO = null;
      this.elinor.idle();

      this.btnReplay.canPlayVO = true;
      this.btnNext.canPlayVO = true;
    }
  }

  onClickElinor() {
    if (this.selectedSlot) return;

    //
    this.idleTime = -1;
    if (this.idleVO && this.idleVO.isPlaying) {
      this.idleVO.stop();
      this.idleVO = null;
    }

    // select one of the slot
    const ind = Phaser.Math.between(0, this.slots.length - 1);
    this.selectedSlotEl = this.slots[ind];
    const stars = this.selectedSlotEl.stars.stars;

    for (let i = 0; i < this.slots.length; i++) {
      if (i !== ind) {
        this.slots[i].makeSmaller();
      } else {
        this.slots[i].makeBigger();
      }
    }
    // this.selectedSlotEl.makeBigger();
    this.elinor.disable();

    //
    this.btnReplay.canPlayVO = false;
    this.btnNext.canPlayVO = false;

    //
    this.elinorClicked = true;
    this.elinor.talk();

    const voId = 'ex_' + stars + '_star';
    this.starVO = this.game.sounds.playVO(voId, {
      spriteID: 'vo_explainer_stars',
      onComplete: this.playStarVO,
      onCompleteScope: this,
    });
    this.game.springRollCaptionsPlugin.playCaption(voId);
  }

  playStarVO() {
    if (this.elinorClicked) {
      const stars = this.selectedSlotEl.stars.stars;
      const varId = Phaser.Math.between(1, stars === 3 ? 2 : 4);
      const voId = 'ex_' + stars + '_star_variable_' + varId;
      this.starVO = this.game.sounds
        .playVO(voId, {
          spriteID: 'vo_explainer_stars',
          onComplete: this.handleStarVOComplete,
          onCompleteScope: this,
        })
        .get(voId);
      this.game.springRollCaptionsPlugin.playCaption(voId);
    }
  }

  handleStarVOComplete() {
    if (this.elinorClicked) {
      const stars = this.selectedSlotEl.stars.stars;
      if (stars < 3 && Math.random() < 0.5) {
        const voId = 'ex_1_2_star_variable';
        this.starVO = this.game.sounds
          .playVO(voId, {
            spriteID: 'vo_explainer_stars',
            onComplete: this.endStarVO,
            onCompleteScope: this,
          })
          .get(voId);
        this.game.springRollCaptionsPlugin.playCaption(voId);
      } else {
        this.endStarVO();
      }
    }
  }

  endStarVO() {
    this.elinorClicked = false;
    if (this.starVO && this.starVO.isPlaying) this.starVO.stop();
    // this.selectedSlotEl && this.selectedSlotEl.makeNormal();

    if (this.slots) {
      for (let i = 0; i < this.slots.length; i++) {
        this.slots[i].makeNormal();
      }
    }

    if (this.elinor) {
      this.elinor.idle();
      this.elinor.enable();
    }

    if (this.btnReplay) {
      this.btnReplay.canPlayVO = true;
      this.btnNext.canPlayVO = true;
    }

    // reset idle timer
    this.idleTime = 0;
  }

  destroy() {
    this.elinorClicked = false;
    if (this.starVO && this.starVO.isPlaying) this.starVO.stop();
    this.starVO = null;

    this.btnReplay.onInputDown.remove(this.handleReplayDown, this);
    this.btnNext.onInputDown.remove(this.handleNextDown, this);

    this.elinor.onClick.remove(this.onClickElinor, this);
    this.elinor.disable();
    this.elinor = null;

    super.destroy();
  }
}
